module.exports = __webpack_public_path__ + "static/media/adidas.00996ad5.png";